export const baseUrl = process.env.REACT_APP_CONNECT_PATH;
export const oldUrl = process.env.REACT_APP_OLD_CONNECT_PATH;
export const webBaseUrl = process.env.REACT_APP_WEBSITE_PATH;
